import React from 'react';
import PropTypes from 'prop-types';
import DocumentShareConstants from 'DocumentShare/DocumentShareConstants';
import { formatDateWithTime } from 'Utils';
import { ACCESS_LEVEL_MAP } from './SignatureAuditButtonConstants';

class SignatureAuditModalRow extends React.PureComponent {
  static getTimeSigned(updatedAt) {
    const parsedDate = new Date(Date.parse(updatedAt));
    return formatDateWithTime(parsedDate);
  }

  render() {
    const { auditItem } = this.props;
    if (auditItem.share_key) {
      return (
        <tr key={auditItem.share_key}>
          <td>{auditItem.share_email || 'Share Link'}</td>
          <td>{ACCESS_LEVEL_MAP[auditItem.access_level]}</td>
          <td>{SignatureAuditModalRow.getTimeSigned(auditItem.updated_at)}</td>
          <td>{auditItem.ip_address}</td>
        </tr>
      );
    }
    return (
      <tr key="owner-signature">
        <td>{auditItem.share_email}</td>
        <td>{ACCESS_LEVEL_MAP[DocumentShareConstants.SIGN_DONE_MODE]}</td>
        <td>{SignatureAuditModalRow.getTimeSigned(auditItem.updated_at)}</td>
        <td>{auditItem.ip_address}</td>
      </tr>
    );
  }
}

SignatureAuditModalRow.propTypes = {
  auditItem: PropTypes.shape({
    access_level: PropTypes.string,
    ip_address: PropTypes.string.isRequired,
    share_email: PropTypes.string,
    share_key: PropTypes.string,
    updated_at: PropTypes.string.isRequired,
  }).isRequired,
};

export default SignatureAuditModalRow;



// WEBPACK FOOTER //
// ./src-react/SignatureAuditButton/SignatureAuditModalRow.jsx